const utils = require('frontend-controller/lib/utils')

module.exports = {
	model: {
		options: {}
	},

	events: {
		change: {
			type: 'change',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target).closest('select');
				var value = $target.val();
				if(!value) value = null;
				self.triggerClosest('onChildChanged', {
					fieldCode: self.model.fieldCode,
					value: value
				});
			}
		}
	},

	methods: {
		sanitizeResources: function(storage){
			var self = this;
			this.model.options = {};
			var text;

			utils.forEach((this.model['resource-picker-data'] || {}).options || [], function (pickerData) {
				var componentData = pickerData.resource || {};
				var primaryKey = (componentData.attributes || {})[componentData.primaryKey || 0] || 0;
				if(primaryKey){
					text = 'ComponentID: ' + (primaryKey || '??');
					if(componentData.children.cpTpl.data.attributes) {
						var template = componentData.children.cpTpl.data.attributes;

						// estimate right text for this leaf
						text = template.tplSrcFile;
					}
					if(storage.user && componentData.relationships && componentData.relationships.cms_componentsTrl && Array.isArray(componentData.relationships.cms_componentsTrl.data)){
						utils.forEach(componentData.relationships.cms_componentsTrl.data, function(translation){
							if(translation.attributes.langCode == storage.langCode && !utils.isEmpty(translation.attributes.name)){
								text = translation.attributes.name;
								return false;
							}
						});
					}

					self.model.options[primaryKey] = text;
				}
			});
		}
	}
}